import * as CX from './Concept';

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_ARTIFACT = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'ro'],
	[CX.BUSINESS_FUNCTION, 'ro'],
	[CX.BUSINESS_INTERACTION, 'ro'],
	[CX.BUSINESS_INTERFACE, 'ro'],
	[CX.BUSINESS_OBJECT, 'ro'],
	[CX.BUSINESS_PROCESS, 'ro'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'ro'],
	[CX.BUSINESS_CONTRACT, 'ro'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'ro'],
	[CX.APPLICATION_COMPONENT, 'ro'],
	[CX.APPLICATION_EVENT, 'ro'],
	[CX.APPLICATION_FUNCTION, 'ro'],
	[CX.APPLICATION_INTERACTION, 'ro'],
	[CX.APPLICATION_INTERFACE, 'ro'],
	[CX.APPLICATION_PROCESS, 'ro'],
	[CX.APPLICATION_SERVICE, 'ro'],
	[CX.APPLICATION_DATA_OBJECT, 'ro'],
	[CX.TECHNOLOGY_ARTIFACT, 'scgro'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'ro'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'ro'],
	[CX.TECHNOLOGY_FUNCTION, 'ro'],
	[CX.TECHNOLOGY_INTERACTION, 'ro'],
	[CX.TECHNOLOGY_INTERFACE, 'ro'],
	[CX.TECHNOLOGY_PROCESS, 'ro'],
	[CX.TECHNOLOGY_SERVICE, 'ro'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'scgrno'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_COMMUNICATION_NETWORK = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'rno'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'rvtfo'],
	[CX.BUSINESS_COLLABORATION, 'rvtfo'],
	[CX.BUSINESS_EVENT, 'rvtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'rvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'rvtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'rvtfo'],
	[CX.APPLICATION_COMPONENT, 'rvtfo'],
	[CX.APPLICATION_EVENT, 'rvtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'rvtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'iao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'scgvtfo'],
	[CX.TECHNOLOGY_DEVICE, 'grvtfo'],
	[CX.TECHNOLOGY_NODE, 'rvtfo'],
	[CX.TECHNOLOGY_PATH, 'rvtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'girvtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'rvtfo'],
	[CX.TECHNOLOGY_EVENT, 'irvtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'girvtfo'],
	[CX.TECHNOLOGY_PROCESS, 'irvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'irvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'rvtfo'],
	[CX.PHYSICAL_FACILITY, 'rvtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_DEVICE = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'rvtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'rvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'rvtfo'],
	[CX.APPLICATION_COMPONENT, 'rvtfo'],
	[CX.APPLICATION_EVENT, 'rvtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'rvtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'iao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'scgvtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'cgirvtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'irvtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'cgirvtfo'],
	[CX.TECHNOLOGY_PROCESS, 'irvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'irvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_NODE = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'ino'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'ivtfo'],
	[CX.BUSINESS_COLLABORATION, 'ivtfo'],
	[CX.BUSINESS_EVENT, 'irvtfo'],
	[CX.BUSINESS_FUNCTION, 'irvtfo'],
	[CX.BUSINESS_INTERACTION, 'irvtfo'],
	[CX.BUSINESS_INTERFACE, 'irvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'irvtfo'],
	[CX.BUSINESS_ROLE, 'ivtfo'],
	[CX.BUSINESS_SERVICE, 'irvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'rvtfo'],
	[CX.APPLICATION_COMPONENT, 'rvtfo'],
	[CX.APPLICATION_EVENT, 'rvtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'rvtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'iao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'cgirvtfo'],
	[CX.TECHNOLOGY_NODE, 'scgivtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'cgirvtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'irvtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'cgirvtfo'],
	[CX.TECHNOLOGY_PROCESS, 'irvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'irvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'cgirvtfo'],
	[CX.PHYSICAL_FACILITY, 'cgivtfo'],
	[CX.PHYSICAL_MATERIAL, 'iao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'io'],
	[CX.IMP_MIG_WORK_PACKAGE, 'io'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_PATH = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'ino'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'ivtfo'],
	[CX.BUSINESS_COLLABORATION, 'ivtfo'],
	[CX.BUSINESS_EVENT, 'irvtfo'],
	[CX.BUSINESS_FUNCTION, 'irvtfo'],
	[CX.BUSINESS_INTERACTION, 'irvtfo'],
	[CX.BUSINESS_INTERFACE, 'irvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'irvtfo'],
	[CX.BUSINESS_ROLE, 'ivtfo'],
	[CX.BUSINESS_SERVICE, 'irvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'rvtfo'],
	[CX.APPLICATION_COMPONENT, 'rvtfo'],
	[CX.APPLICATION_EVENT, 'rvtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'rvtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'iao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'girvtfo'],
	[CX.TECHNOLOGY_NODE, 'givtfo'],
	[CX.TECHNOLOGY_PATH, 'scgvtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'girvtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'gvtfo'],
	[CX.TECHNOLOGY_EVENT, 'irvtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'girvtfo'],
	[CX.TECHNOLOGY_PROCESS, 'irvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'irvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'girvtfo'],
	[CX.PHYSICAL_FACILITY, 'givtfo'],
	[CX.PHYSICAL_MATERIAL, 'iao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'io'],
	[CX.IMP_MIG_WORK_PACKAGE, 'io'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_SYSTEM_SOFTWARE = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'rvtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'rvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'rvtfo'],
	[CX.APPLICATION_COMPONENT, 'rvtfo'],
	[CX.APPLICATION_EVENT, 'rvtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'rvtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'iao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'scgirvtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'irvtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'cgirvtfo'],
	[CX.TECHNOLOGY_PROCESS, 'irvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'irvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_COLLABORATION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'ino'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'ivtfo'],
	[CX.BUSINESS_COLLABORATION, 'ivtfo'],
	[CX.BUSINESS_EVENT, 'irvtfo'],
	[CX.BUSINESS_FUNCTION, 'irvtfo'],
	[CX.BUSINESS_INTERACTION, 'irvtfo'],
	[CX.BUSINESS_INTERFACE, 'irvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'irvtfo'],
	[CX.BUSINESS_ROLE, 'ivtfo'],
	[CX.BUSINESS_SERVICE, 'irvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'rvtfo'],
	[CX.APPLICATION_COMPONENT, 'rvtfo'],
	[CX.APPLICATION_EVENT, 'rvtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'rvtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'iao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'girvtfo'],
	[CX.TECHNOLOGY_NODE, 'givtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'girvtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'scgvtfo'],
	[CX.TECHNOLOGY_EVENT, 'irvtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'irvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'cgirvtfo'],
	[CX.TECHNOLOGY_PROCESS, 'irvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'irvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'girvtfo'],
	[CX.PHYSICAL_FACILITY, 'givtfo'],
	[CX.PHYSICAL_MATERIAL, 'iao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'io'],
	[CX.IMP_MIG_WORK_PACKAGE, 'io'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_EVENT = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'rvtfo'],
	[CX.BUSINESS_FUNCTION, 'vtfo'],
	[CX.BUSINESS_INTERACTION, 'vtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'vtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'vtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'rvtfo'],
	[CX.APPLICATION_FUNCTION, 'vtfo'],
	[CX.APPLICATION_INTERACTION, 'vtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'vtfo'],
	[CX.APPLICATION_SERVICE, 'vtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'scgvtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_FUNCTION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'scgvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'cgvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'cgvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'rvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_INTERACTION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'cgvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'scgvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'cgvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'rvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_INTERFACE = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'vtfo'],
	[CX.BUSINESS_INTERACTION, 'vtfo'],
	[CX.BUSINESS_INTERFACE, 'rvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'vtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'vtfo'],
	[CX.APPLICATION_INTERACTION, 'vtfo'],
	[CX.APPLICATION_INTERFACE, 'rvtfo'],
	[CX.APPLICATION_PROCESS, 'vtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'scgvtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'ivtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_PROCESS = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'rvtfo'],
	[CX.APPLICATION_INTERACTION, 'rvtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'rvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'cgvtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'cgvtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'scgvtfo'],
	[CX.TECHNOLOGY_SERVICE, 'rvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_TECHNOLOGY_SERVICE = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'vtfo'],
	[CX.BUSINESS_INTERACTION, 'vtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'vtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'vtfo'],
	[CX.APPLICATION_INTERACTION, 'vtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'vtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'scgvtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);
